import * as FieldType from '../FieldBuilder/FieldConstants';
import getValidators from '../FieldBuilder/FieldValidator';

/**
 * Create fields to FormBuilder from configs (field.json and formconfig.json files base vonfigs).
 *
 * @param {Object} groups original group configs (formconfig.json)
 * @param {Object} fields original fields config (fields.json)
 */
export const buildFormBuilderFields = (groups, fields) => {
  return groups.map((group) => {
    return group.fields
      .map((field) => {
        return { ...fields[field], id: field };
      })
      .filter(Boolean)
      .reduce((result, field) => {
        const { id, sameas, type, sublist, formField } = field;
        const currentField = {
          validators: getValidators(field),
          sameas: sameas,
          value: '',
          valid: true,
          checkbox: type === FieldType.CHECKBOX_FIELD,
          list: type === FieldType.LIST_FIELD ? [] : null,
          formField
        };
        currentField.valid = isValid(currentField);
        result[id] = currentField;
        if (sameas) {
          result[`_${id}`] = { ...result[id] };
        }
        if (sublist) {
          const sublistId = sublist.id;
          const sublistField = {
            ...result[id],
            parent: id,
          };
          sublistField.valid = isValid(sublistField);
          currentField.child = sublistId;
          result[sublistId] = sublistField;
        }
        return result;
      }, {});
  });
};

/**
 * Validate field.
 *
 * @param {Object} field field
 */
export const isValid = (field) => {
  return field.validators
    .map((validator) => {
      return validator(field);
    })
    .every(Boolean);
};
